var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-button',_vm._b({attrs:{"loading":_vm.loading},on:{"on-click":_vm.onClick}},'n-button',_vm.attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }